import { Modal, Row } from 'antd';
import styled from 'styled-components';

import { typography } from '~/theme';
import CommonButton from '~atoms/CommonButton';

export const Container = styled(Modal)(({ theme }) => ({
  '& .ant-col': {
    paddingLeft: 0,
    paddingRight: 0,
  },
  '& .ant-modal-content': {
    background: `${theme.palette.white} 0% 0% no-repeat padding-box`,
    padding: '30rem',
  },
}));

export const Title = styled.h3(({ theme }) => ({
  color: theme.page.title.text,
  fontFamily: typography.family.playfairDisplay,
  fontSize: theme.typography.size24,
  margin: 0,
  fontWeight: 'normal',
}));

export const ContentContainer = styled(Row)(({ theme }) => ({
  fontFamily: typography.family.arial,
  fontSize: theme.typography.size16,
}));

export const DialogButton = styled(CommonButton)(({ theme }) => ({
  height: '38rem',
  paddingInline: '20rem',
  marginInlineStart: 'auto',
  fontSize: theme.typography.size20,
}));
